import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { IconAndText } from 'components/shared/SvgAF/SvgAF';
import classnames from 'classnames';

export default class AccordionSection extends Component {
  static propTypes = {
    children: PropTypes.instanceOf(Object).isRequired,
    isOpen: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    iconLeft: PropTypes.bool,
    iconOpened: PropTypes.string.isRequired,
    hoverOpened: PropTypes.string.isRequired,
    iconClosed: PropTypes.string.isRequired,
    hoverClosed: PropTypes.string.isRequired
  };

  onClick = () => {
    this.props.onClick(this.props.label);
    if (this.props.resizeModal) {
      this.props.resizeModal(this.props.isOpen);
    }
  };

  render() {
    const {
      onClick,
      props: { label, isOpen, iconLeft, iconOpened, hoverOpened, iconClosed, hoverClosed, fetching }
    } = this;

    return (
      <div className="accordionOuterContainer">
        <div className="accordionSectionContainer" onClick={onClick}>
          <div className="moreInfoIconContainer">
            <IconAndText
              text={label}
              img={isOpen ? iconOpened : iconClosed}
              hoverImg={isOpen ? hoverOpened : hoverClosed}
              reverse={iconLeft ? false : true}
            />
          </div>
        </div>
        {isOpen && (
          <div
            className={classnames({
              openedSectionContainer: true,
              accordionSection_disabled_button: fetching
            })}
          >
            {this.props.children}
          </div>
        )}
      </div>
    );
  }
}
